module.exports = __webpack_public_path__ + "img/c98b5d024d52d3fda76bebd64a63e9b9.svg";